<template>
  <div
    class="close-container navigation-wrap"
    :class="{ line: line }"
    :style="isBlue ? 'background: #0054F0' : ' background: #E40000'"
  >
    <div class="left-container">
      <slot name="left">
        <i v-if="showIconBack" class="bluepay-icon-back cursor-pointer" @click="clickLeft" />
      </slot>
    </div>

    <span class="head-title">{{ title }}</span>

    <slot name="right" />
  </div>
</template>
<script>
export default {
  name: 'CustomNavbar',
  props: {
    title: {
      type: String,
      default: ''
    },
    line: {
      type: Boolean,
      default: false
    },
    showIconBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    isBlue() {
      return !!this.$store.getters.isBluepay
    }
  },
  mounted() {},
  methods: {
    clickLeft() {
      this.$emit('clickLeft')
    }
  }
}
</script>
<style lang="less" scoped>
.line {
  border-bottom: 1px solid #e8e8e8;
}
// .left-container{
//   // flex: 1;
//   // position: relative;
//   // text-align: center;
// }

.close-container {
  padding: 0 16px;
  font-size: 17px;
  font-weight: 500;
  line-height: 22px;
  color: #fff;
  // background: #0054F0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .head-title {
    text-wrap: nowrap;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .bluepay-icon-back {
    font-size: 24px;
  }
}
.navigation-wrap {
  height: 60px;
}
</style>
